import documentLibraryRouteConfig from './document-library.routes';
import { DocumentLibraryComponent } from './views/document-library/document-library';
import { BoxContentExplorerComponent } from './components/box-content-explorer/box-content-explorer.component';

export default angular
  .module('sfMobile.documentLibrary', ['sfMobile.services.document-library'])
  .component('sfDocumentLibrary', DocumentLibraryComponent)
  .component('sfBoxContentExplorer', BoxContentExplorerComponent)
  .config(documentLibraryRouteConfig).name;
